module.exports = __parcel__import__.meta.resolve("3NZ96");